import type { ReactNode } from "react";
import AppSidebarLayout from "./AppSidebarLayout";
import { Outlet } from "react-router-dom";

export default function DashboardLayout({ children }: { children?: ReactNode }) {
  return (
    <AppSidebarLayout>
      {children ?? <Outlet />}
    </AppSidebarLayout>
  );
}




